import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import {
  GOVGR_FIELD,
  GOVGR_FIELD__ERROR,
  GOVGR_LABEL,
} from "../../conf/styles/GovGrFileInput";
import DeleteButton from "./DeleteButton";
import ErrorText from "./Error";
import Input from "./Input";
import Label from "./Label";
import ViewButton from "./ViewButton";

const LABEL = "Upload file";
const DISABLED_INITIAL_VALUE = false;

const useStyles = makeStyles({
  controlsContainer: {
    maxWidth: "30rem",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "wrap",
  },
});

const FileUpload = ({
  label = LABEL,
  hint,
  errorLabel,
  accept,
  document,
  disabled = DISABLED_INITIAL_VALUE,
  InputProps: inputProps,
  InputLabelProps: inputLabelProps,
  disableDeleteButton,
  disableViewButton,
  onChange,
  handleViewFile,
  handleDeleteFile,
  uploadedFilename,
  initiallyUploadedDocuments,
}) => {
  const classes = useStyles();

  let ComponentWrapperClass = classNames(GOVGR_FIELD, {
    [GOVGR_FIELD__ERROR]: errorLabel,
  });

  return (
    <div className={ComponentWrapperClass}>
      <label className={GOVGR_LABEL}>
        <Label label={label} hint={hint} {...inputLabelProps} />
        <ErrorText error={errorLabel} />
        <div className={classes.controlsContainer}>
          <Input
            accept={accept}
            name={label}
            disabled={disabled}
            onChange={onChange}
            uploadedFilename={uploadedFilename}
            {...inputProps}
          />
          <div style={{ marginTop: "10px" }}>
            <ViewButton
              handleViewFile={handleViewFile}
              disabled={disableViewButton || !document}
            />
            <DeleteButton
              handleDeleteFile={handleDeleteFile}
              disabled={disableDeleteButton || !document}
            />
          </div>
        </div>
      </label>
    </div>
  );
};

export default FileUpload;
